import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const OrderRequestsStyles: ComponentStylesWithFns = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '40px',
    pt: '32px',
    pb: '20px',
  },
  controls: {
    display: 'flex',
    gap: '10px',
  },
  searchInput: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '8px',
    width: '200px',
    height: '34px',
    '& .MuiInputBase-input': {
      px: '14px',
      py: 0,
      height: '34px',
      fontSize: '13px',
      fontFamily: 'Outfit, Roboto, Helvetica, sans-serif',
      '&::placeholder': {
        color: '#757575',
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  typeSelect: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '8px',
    width: '137px',
    height: '34px',
    fontSize: '13px',
    fontFamily: 'Outfit, Roboto, Helvetica, sans-serif',
    '& .MuiSelect-select': {
      px: '18px',
      py: '0 !important',
      display: 'flex',
      alignItems: 'center',
      height: '34px !important',
      minHeight: 'unset !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  tableWrapper: {
    mx: '40px',
    flex: 1,
    overflow: 'hidden',
    mb: '40px',
  },
  dataGrid: {
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#f5f7fa',
      borderBottom: '1px solid #dce4ee',
      minHeight: '29px !important',
      maxHeight: '29px !important',
      lineHeight: '29px !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontSize: '10px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      color: '#a0aab9',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      minHeight: '50px !important',
      maxHeight: '50px !important',
      '&:nth-of-type(even)': {
        backgroundColor: 'white',
      },
      '&:nth-of-type(odd)': {
        backgroundColor: 'transparent',
      },
      '&:hover': {
        backgroundColor: '#f0f4f8',
      },
      '& .MuiDataGrid-cell': {
        border: 'none',
        borderBottom: '1px solid #dce4ee',
        outline: 'none',
        fontSize: '13px',
        alignItems: 'center',
        display: 'flex',
      },
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #dce4ee',
      minHeight: '40px',
    },
  },
  idCell: {
    fontSize: '10px',
    color: '#a0aab9',
    fontFamily: 'Inter, Roboto, monospace',
    fontStyle: 'normal',
  },
  nameCell: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#111',
  },
  dateCell: {
    fontSize: '13px',
    color: '#111',
  },
  productCell: {
    fontSize: '13px',
    color: '#111',
  },
};
